import React from "react";
import { Link } from "react-router-dom";
import "../styles/styles.css";

function Footer() {
  return (
    <footer className="footer-class">
      <div className="footer-container">
        {/* The "Anchor" - High-impact brand statement */}
        <div className="footer-main-row">
          <div className="footer-statement">
            <h2 className="footer-big-text">
              <span className="italicize">Margin</span> <br />
              is where growth happens.
            </h2>
          </div>

          <div className="footer-nav">
            <div className="footer-nav-col">
              <span className="nav-label">Navigate</span>
              <Link to="/privacy-policy" className="nav-link">
                Privacy & Trust
              </Link>
            </div>

            <div className="footer-nav-col">
              <span className="nav-label">Connect</span>
              <a
                href="https://linkedin.com/company/accesspie-margin/"
                target="_blank"
                rel="noopener noreferrer"
                className="nav-link"
              >
                LinkedIn
              </a>
            </div>
          </div>
        </div>

        {/* The "Signature" - Huge, elegant, and grounded */}
        <div className="footer-signature-wrap">
          <h1 className="footer-giant-logo">MARGIN</h1>
        </div>

        <div className="footer-credits">
          <div className="credit-item">© {new Date().getFullYear()}</div>
          <div className="credit-item italicize">
            Built for the quiet moments.
          </div>
          <div className="credit-item">Memory Vault 1.0</div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
